export default function TS_Conditional_Types() {
  return (
    <div>
      <h1>TS Conditional Types</h1>
      <p>This is the TS Conditional Types page.</p>
    </div>
  );
}